/**
 * 应用的Header
 */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Layout, Dropdown, Menu, message, Switch, Modal } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined, UserOutlined } from '@ant-design/icons';
import ModifyPasswordModal from '@/components/modifyPasswordModal';
import JtAlarmCountIcon from '@/components/jtAlarmCountIcon';
import styles from './index.module.scss';
import { getInformationListRequest, getWebSocketPath, upsertInformationListRequest, upsertserviceOnLineRequest } from '@/utils/common';
import dayjs from 'dayjs';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { getCustomer } from '@/service/login';
import { getInnerPermissionEnable } from '@/utils/permission';
import { getPageTitle } from '@/utils/common';
import { getUserInfoRequest } from '@/service/login';
import { onMenuSelect } from '@/utils/menuManage';
import { displayJtDeviceAlarmV2 } from '@/utils/jtDeviceAlarm';
import { log } from 'console';


const { Header } = Layout;
interface MainHeaderProps {
  collapsed: boolean;
  toggleCollapse: () => void;
}
const MainHeader = (props: MainHeaderProps) => {
  const { collapsed, toggleCollapse } = props;
  const dispatch = useDispatch();
  const { userDetail, menuData, allInnerPermission } = useSelector((state: any) => state.userStore);
  const [modifyVisible, setModifyVisible] = useState(false); // 修改密码的弹窗显示
  const [informationList, setInformationList] = useState<any>([]); // 推送的报警信息
  const [soundSwitch, setSoundSwitch] = useState<any>(false); // 声音开关
  const [onLineSwitch, setOnLineSwitch] = useState<any>(false); // 声音开关
  // const [plateNumber, setPlateNumber] = useState<any>(); // 车牌号
  // const [plateNumberModal, setPlateNumberModal] = useState<any>(true); // 车牌号弹框
  const [messageApi, contextHolder] = message.useMessage();
  const orderMp = require('../../assets/video/order.mp3')
  const customertaskMp = require('../../assets/video/customertask.mp3')
  const alarmMp = require('../../assets/video/alarm.mp3')
  const [lockReconnect, setLockReconnect] = useState(false); // 避免ws重复连接
  const [lockReconnectAlarm808, setLockReconnectAlarm808] = useState(false); // 避免wsAlarm808重复连接
  const [videoDuration, setVideoDuration] = useState<number>(); // 剩余时长
  const [menuOpen, setMenuOpen] = useState(false); // 快捷菜单的显示
  const [accpetVideo, setAccpetVideo] = useState(false)
  const alarm808MessageTimerRef = useRef<NodeJS.Timeout | null>(null); // alarm808消息提示防抖timer

  const openaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2408" width="18" height="18"><path d="M128 420.576v200.864h149.12l175.456 140.064V284.288l-169.792 136.288H128z m132.256-64l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM670.784 720.128a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872c84.16 89.28 131.84 207.04 131.84 332.256 0 127.84-49.76 247.904-137.088 337.728z" fill="#2c2c2c" p-id="2409"></path></svg>
  )
  const closeaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2929" width="18" height="18"><path d="M128 420.576v200.864h149.12l175.456 140.064V284.288l-169.792 136.288H128z m132.256-64l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM752 458.656L870.4 300.8a32 32 0 1 1 51.2 38.4L792 512l129.6 172.8a32 32 0 0 1-51.2 38.4l-118.4-157.856-118.4 157.856a32 32 0 0 1-51.2-38.4l129.6-172.8-129.6-172.8a32 32 0 0 1 51.2-38.4l118.4 157.856z" fill="#000000" p-id="2930"></path></svg>
  )
  const not = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3424" width="50" height="50"><path d="M475.829476 1024C551.912302 1024 611.780755 962.884287 611.780755 888.048721H339.878197c0 74.835566 61.115713 135.951279 135.951279 135.951279zM772.677223 140.940317c-102.275274 0-184.594397 63.610231-184.594397 143.434835 0 78.577345 82.319123 143.434836 184.594397 143.434836 102.275274 0 184.594397-63.610231 184.594397-143.434836s-82.319123-143.434836-184.594397-143.434835z m-87.308161 167.132765c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929 13.719854 0 23.697929 11.225335 23.697929 23.697929 1.247259 13.719854-9.978076 23.697929-23.697929 23.69793z m87.308161 0c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929s23.697929 11.225335 23.697929 23.697929c0 13.719854-9.978076 23.697929-23.697929 23.69793z m86.060901 0c-13.719854 0-23.697929-11.225335-23.697929-23.69793 0-13.719854 11.225335-23.697929 23.697929-23.697929s23.697929 11.225335 23.69793 23.697929c1.247259 13.719854-9.978076 23.697929-23.69793 23.69793z" fill="#E5E5E7" p-id="3425"></path><path d="M838.781973 750.850183c-44.90134 0-44.90134-180.852619-44.90134-180.852619V462.733252c-6.236297 0-13.719854 1.247259-19.956151 1.24726-122.231425 0-222.01218-81.071864-222.01218-180.852619 0-57.373934 33.676005-108.511571 86.060901-142.187576-22.45067-14.967113-46.148599-26.192448-72.341047-34.923265 1.247259-4.989038 1.247259-9.978076 1.247259-14.967113 0-49.890378-41.159562-91.049939-91.049939-91.049939s-91.049939 41.159562-91.049939 91.049939c0 4.989038 0 9.978076 1.24726 14.967113-125.973203 43.65408-228.248477 178.3581-228.248478 336.760049v124.725944s0 180.852619-43.65408 182.099878c-26.192448 0-46.148599 19.956151-46.1486 44.90134S87.93179 839.405603 112.876979 839.405603h725.904994c24.945189 0 44.90134-19.956151 44.90134-44.90134 1.247259-22.45067-19.956151-43.65408-44.90134-43.65408z m-361.705237-619.887942c-19.956151 0-37.417783-16.214373-37.417784-37.417783 0-19.956151 16.214373-37.417783 37.417784-37.417783 19.956151 0 37.417783 16.214373 37.417783 37.417783-1.247259 21.20341-17.461632 37.417783-37.417783 37.417783z" fill="#E5E5E7" p-id="3426"></path></svg>
  )
  const OpenSoundIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={openaaa} {...props} />
  );
  const CloseSoundIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={closeaaa} {...props} />
  );
  const NotInformationIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={not} {...props} />
  );

  const orderaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15245" width="37" height="37"><path d="M512 512m-448.2 0a448.2 448.2 0 1 0 896.4 0 448.2 448.2 0 1 0-896.4 0Z" fill="#53B7F4" p-id="15246"></path><path d="M618.2 518c-55.3 0-100.1 44.9-100.1 100.2 0 39.8 23.6 75.9 60.1 91.8H376.1c-18.4 0-33.4-14.9-33.4-33.4V384.4c0-18.4 14.9-33.4 33.4-33.4h16.7v20.9c0 20.7 16.8 37.6 37.6 37.6H589c20.7 0 37.6-16.8 37.6-37.6V351h16.7c18.4 0 33.4 14.9 33.4 33.4v152.5c-17.1-12.3-37.5-18.9-58.5-18.9zM409.5 618.2h50.1c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7h-50.1c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7z m0-66.8H518c9.2 0 16.7-7.5 16.7-16.7S527.2 518 518 518H409.5c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7z m200.3-100.2H409.5c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7h200.3c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7z m-33.4-58.4H442.9c-18.4 0-33.4-14.9-33.4-33.4 0-18.4 14.9-33.4 33.4-33.4h133.6c18.4 0 33.4 14.9 33.4 33.4-0.1 18.4-15 33.4-33.5 33.4z" fill="#29A3D3" p-id="15247"></path><path d="M668.3 601.5v8l-16.7 17h-25l-16.7 50.1h-41.7l16.7-50.1h-16.7v-58.4h83.5l16.7 16.3v8.7h25v8.3h-25.1v0.1z" fill="#29A3D3" p-id="15248"></path><path d="M612.2 512c-55.3 0-100.1 44.9-100.1 100.2 0 39.8 23.6 75.9 60.1 91.8H370.1c-18.4 0-33.4-14.9-33.4-33.4V378.4c0-18.4 14.9-33.4 33.4-33.4h16.7v20.9c0 20.7 16.8 37.6 37.6 37.6H583c20.7 0 37.6-16.8 37.6-37.6V345h16.7c18.4 0 33.4 14.9 33.4 33.4v152.5c-17.1-12.3-37.5-18.9-58.5-18.9zM403.5 612.2h50.1c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7h-50.1c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7z m0-66.8H512c9.2 0 16.7-7.5 16.7-16.7S521.2 512 512 512H403.5c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7z m200.3-100.2H403.5c-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7h200.3c9.2 0 16.7-7.5 16.7-16.7s-7.5-16.7-16.7-16.7z m-33.4-58.4H436.9c-18.4 0-33.4-14.9-33.4-33.4 0-18.4 14.9-33.4 33.4-33.4h133.6c18.4 0 33.4 14.9 33.4 33.4-0.1 18.4-15 33.4-33.5 33.4z" fill="#FFFFFF" p-id="15249"></path><path d="M662.3 595.5v8l-16.7 17h-25l-16.7 50.1h-41.7l16.7-50.1h-16.7v-58.4h83.5l16.7 16.3v8.7h25v8.3h-25.1v0.1z" fill="#FFFFFF" p-id="15250"></path></svg>
  )
  const OrderIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={orderaaa} {...props} />
  );
  const customertaskaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13961" width="37" height="37"><path d="M512 127.0272c-133.4144 0-192.4864 72.1792-192.4864 192.4864V656.384h384.9856V319.5136c-0.0128-120.3072-78.72-192.4864-192.4992-192.4864z" fill="#A67C52" p-id="13962"></path><path d="M560.128 487.9488h-96.256l-24.0512 96.2432v312.8064h144.3584V584.192z" fill="#DBB59A" p-id="13963"></path><path d="M223.2576 704.4992c-45.2352 45.2352-48.128 192.4864-48.128 192.4864H512L415.7568 608.256s-169.8944 73.6256-192.4992 96.2432z m577.4848 0C778.112 681.8688 608.256 608.256 608.256 608.256L512 896.9984h336.8576s-2.88-147.264-48.1152-192.4992z" fill="#48A0DC" p-id="13964"></path><path d="M584.1792 584.192L512 896.9984h24.064l72.1792-168.4352 120.3072-24.064-144.3712-120.3072z m-288.7296 120.3072l120.3072 24.064 72.1792 168.4352H512L439.8208 584.192l-144.3712 120.3072z" fill="#FFFFFF" p-id="13965"></path><path d="M578.2144 270.976c-18.8288 41.6384-83.7888 72.6016-162.4576 72.6016h-47.7824c1.0496 47.1424 5.44 83.7248 23.7312 120.3072 24.064 48.128 73.1648 96.2432 120.3072 96.2432S608.256 512 632.32 463.8848c21.4272-42.8416 23.7696-85.696 24.0256-145.5232-1.4208-27.0464-52.48-47.3856-78.1312-47.3856z" fill="#F6CBAD" p-id="13966"></path><path d="M723.6864 283.8912c-21.0176-75.904-107.8016-132.8-211.6864-132.8s-190.6688 56.896-211.6864 132.8c-16.0512 8.8064-28.928 21.504-28.928 35.6224v48.128c0 26.5728 45.6064 48.128 72.1792 48.128v-96.2432c0-66.4448 75.4048-120.3072 168.4352-120.3072s168.4352 53.8624 168.4352 120.3072v48.128c0 51.5712-32.448 95.552-78.0288 112.6656-6.4384-9.8816-17.5872-16.4224-30.2464-16.4224h-48.128c-19.9296 0-36.096 16.1664-36.096 36.096 0 19.9296 16.1664 36.096 36.096 36.096H572.16c3.52 0 6.912-0.512 10.1248-1.4464 70.9888-9.3312 128.0512-62.8608 142.6432-132.0576 15.4752-8.768 27.6992-21.1712 27.6992-34.9184v-48.128c-0.0128-14.144-12.8896-26.8416-28.9408-35.648z" fill="#4D4D4D" p-id="13967"></path></svg>
  )
  const CustomertaskIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={customertaskaaa} {...props} />
  );
  const alarmaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2770" width="37" height="37"><path d="M216.4224 315.4944c-7.5776 0-15.1552-2.7648-21.0944-8.3456l-50.9952-48.0768a30.73024 30.73024 0 0 1-1.28-43.4176 30.73024 30.73024 0 0 1 43.4176-1.28l50.9952 48.0768a30.73024 30.73024 0 0 1 1.28 43.4176 30.6176 30.6176 0 0 1-22.3232 9.6256zM786.4832 315.4944c-8.1408 0-16.3328-3.2256-22.3744-9.6256a30.73024 30.73024 0 0 1 1.28-43.4176l50.9952-48.0768a30.73024 30.73024 0 0 1 43.4176 1.28 30.73024 30.73024 0 0 1-1.28 43.4176l-50.9952 48.0768a30.47936 30.47936 0 0 1-21.0432 8.3456zM501.4528 226.3552c-16.9472 0-30.72-13.7728-30.72-30.72V117.76c0-16.9472 13.7728-30.72 30.72-30.72s30.72 13.7728 30.72 30.72v77.8752c0 16.9472-13.7728 30.72-30.72 30.72zM848.2304 845.2608h-49.5616v-301.1584c0-161.8944-131.7376-293.632-293.632-293.632s-293.632 131.7376-293.632 293.632v301.1584H172.032c-16.9472 0-30.72 13.7728-30.72 30.72s13.7728 30.72 30.72 30.72h676.1984c16.9472 0 30.72-13.7728 30.72-30.72s-13.7728-30.72-30.72-30.72z m-224.7168-227.8912l-119.808 127.3856a30.49984 30.49984 0 0 1-22.3744 9.6768c-7.5264 0-15.104-2.7648-21.0432-8.3456-12.3392-11.6224-12.9536-31.0784-1.3312-43.4176l71.1168-75.6224H413.0816c-12.4928 0-23.7056-7.5264-28.416-19.0976s-1.9968-24.832 6.912-33.536L508.4672 459.776a30.78144 30.78144 0 0 1 43.4688 0.4096 30.78144 30.78144 0 0 1-0.4096 43.4688l-63.1808 61.952h112.8448c12.2368 0 23.3472 7.2704 28.2112 18.5344 4.8128 11.2128 2.5088 24.2688-5.888 33.2288z" fill="#FF5757" p-id="2771"></path></svg>
  )
  const AlarmIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={alarmaaa} {...props} />
  );
  const Customecommentaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15880" width="37" height="37"><path d="M672.36 905.02H308.78c-83.26 0-150.76-67.5-150.76-150.76V269.75c0-83.26 67.5-150.76 150.76-150.76h363.58c83.26 0 150.76 67.5 150.76 150.76v484.51c0 83.26-67.5 150.76-150.76 150.76z" fill="#1581dc" p-id="15881" data-spm-anchor-id="a313x.7781069.0.i18"></path><path d="M644.86 815.69H336.28c-56.71 0-102.68-45.97-102.68-102.68V310.99c0-56.71 45.97-102.68 102.68-102.68h308.58c56.71 0 102.68 45.97 102.68 102.68v402.03c0 56.7-45.97 102.67-102.68 102.67z" fill="#6bb9fa" p-id="15882" data-spm-anchor-id="a313x.7781069.0.i25"></path><path d="M619.06 375.96H316.74c-20.87 0-37.79-16.92-37.79-37.79 0-20.87 16.92-37.79 37.79-37.79h302.32c20.87 0 37.79 16.92 37.79 37.79 0 20.87-16.92 37.79-37.79 37.79zM528.36 512H316.74c-20.87 0-37.79-16.92-37.79-37.79 0-20.87 16.92-37.79 37.79-37.79h211.62c20.87 0 37.79 16.92 37.79 37.79 0 20.87-16.92 37.79-37.79 37.79z" fill="#FFFBE8" p-id="15883"></path><path d="M828.25 460.19c-36.91-22.28-84.91-10.43-107.19 26.49L567.39 741.22c-0.07 0.12-0.1 0.25-0.18 0.37l83.61 14.74 50.86 64.57 153.05-253.53c22.29-36.9 10.43-84.9-26.48-107.18z" fill="#F9C662" p-id="15884"></path><path d="M650.82 756.34l-83.61-14.74c-0.51 0.86-0.79 1.79-1.26 2.66 0.05 10.41 0.31 48.54 1.53 77.13 0.53 12.45 1.23 23.11 2.19 28.73 4.56 26.87 16.38 23.47 29.28 22.46 4.29-0.34 17.29-5.98 32.68-13.32 24.65-11.75 55.38-27.85 66.89-33.93 0.81-1.19 1.81-2.17 2.56-3.41l0.61-1.02-50.87-64.56z" fill="#FFDA8F" p-id="15885"></path></svg>
  )
  const CustomecommentIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={Customecommentaaa} {...props} />
  );

  const Customecommentaaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15880" width="37" height="37"><path d="M672.36 905.02H308.78c-83.26 0-150.76-67.5-150.76-150.76V269.75c0-83.26 67.5-150.76 150.76-150.76h363.58c83.26 0 150.76 67.5 150.76 150.76v484.51c0 83.26-67.5 150.76-150.76 150.76z" fill="#1581dc" p-id="15881" data-spm-anchor-id="a313x.7781069.0.i18"></path><path d="M644.86 815.69H336.28c-56.71 0-102.68-45.97-102.68-102.68V310.99c0-56.71 45.97-102.68 102.68-102.68h308.58c56.71 0 102.68 45.97 102.68 102.68v402.03c0 56.7-45.97 102.67-102.68 102.67z" fill="#6bb9fa" p-id="15882" data-spm-anchor-id="a313x.7781069.0.i25"></path><path d="M619.06 375.96H316.74c-20.87 0-37.79-16.92-37.79-37.79 0-20.87 16.92-37.79 37.79-37.79h302.32c20.87 0 37.79 16.92 37.79 37.79 0 20.87-16.92 37.79-37.79 37.79zM528.36 512H316.74c-20.87 0-37.79-16.92-37.79-37.79 0-20.87 16.92-37.79 37.79-37.79h211.62c20.87 0 37.79 16.92 37.79 37.79 0 20.87-16.92 37.79-37.79 37.79z" fill="#FFFBE8" p-id="15883"></path><path d="M828.25 460.19c-36.91-22.28-84.91-10.43-107.19 26.49L567.39 741.22c-0.07 0.12-0.1 0.25-0.18 0.37l83.61 14.74 50.86 64.57 153.05-253.53c22.29-36.9 10.43-84.9-26.48-107.18z" fill="#F9C662" p-id="15884"></path><path d="M650.82 756.34l-83.61-14.74c-0.51 0.86-0.79 1.79-1.26 2.66 0.05 10.41 0.31 48.54 1.53 77.13 0.53 12.45 1.23 23.11 2.19 28.73 4.56 26.87 16.38 23.47 29.28 22.46 4.29-0.34 17.29-5.98 32.68-13.32 24.65-11.75 55.38-27.85 66.89-33.93 0.81-1.19 1.81-2.17 2.56-3.41l0.61-1.02-50.87-64.56z" fill="#FFDA8F" p-id="15885"></path></svg>
  )
  const UnderwritingIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={Customecommentaaaa} {...props} />
  );


  useEffect(() => {
    getOnline()
    //取得本地存储的数据
    const userDetailIf: any = localStorage.getItem('userDetail-websoket')
    // console.log('userDetailIf', userDetailIf === 'false')
    if (userDetailIf === 'false') {
      openWs();

      // setTimeout(() => {
      //   $(document).on('click', () => {
      //     const order = (document.getElementById('order') as HTMLElement as any)
      //     const customertask = (document.getElementById('customertask') as HTMLElement as any)
      //     const alarm = (document.getElementById('alarm') as HTMLElement as any)
      //     order
      //     if (order) {
      //       order.muted =  false;
      //     }
      //     if (customertask) {
      //       customertask.muted =  false;
      //     }
      //     if (alarm) {
      //       alarm.muted =  false;
      //     }
      //   })
      // })

    }
  }, []);

  // 单独的 useEffect 处理 alarm808 WebSocket 连接，依赖 allInnerPermission
  useEffect(() => {
    // 只有当 allInnerPermission 有数据时才检查权限
    if (allInnerPermission && allInnerPermission.length > 0) {
      const jtAlarmWsPermission = getInnerPermissionEnable('/car-admin/jt-alarm-ws');
      console.log('jtAlarmWsPermission alarm808', jtAlarmWsPermission)
      if (jtAlarmWsPermission) {
        openWsAlarm808();
      }
    }
  }, [allInnerPermission]);

  const videoChange = (e: boolean) => {
    const order = (document.getElementById('order') as HTMLElement as any)
    const customertask = (document.getElementById('customertask') as HTMLElement as any)
    const alarm = (document.getElementById('alarm') as HTMLElement as any)
    setAccpetVideo(e)
    if (e) {
      if (order) {
        order.muted = false;
      }
      if (customertask) {
        customertask.muted = false;
      }
      if (alarm) {
        alarm.muted = false;
      }
    }
    if (!e) {
      if (order) {
        order.muted = true;
      }
      if (customertask) {
        customertask.muted = true;
      }
      if (alarm) {
        alarm.muted = true;
      }
    }
  }

  // 获取用户剩余时长
  const getVideoDuration = async () => {
    const res = await getUserInfoRequest();
    if (res.data.data.videoDuration == 0) {
      setVideoDuration(0)
    } else {
      const data = res.data.data.videoDuration
      setVideoDuration(data)
      // console.log('videoDuration', videoDuration);
    }
  }

  const getVideoPermission = getInnerPermissionEnable('/car-admin/service-task-dispose/get-video')
  const serviceOnLinePermission = getInnerPermissionEnable('/car-admin/service-task-dispose/service-on-line');
  const jtAlarmCntPermission = getInnerPermissionEnable('/car-admin/jt-alarm-cnt');
  

  const getOnline = async () => {
    const res = await getCustomer();
    if (res.data.data.state == '0') {
      setOnLineSwitch(false)
    } else if (res.data.data.state == '1') {
      setOnLineSwitch(true)
    }
  }



  // if (localStorage?.getItem("code") !== '000000') {
  //   //@ts-ignore
  //   let AppDataProviderBase = UdeskCCPaasApiClass.AppDataProvider;
  //   class AppDataProvider extends AppDataProviderBase {
  //     GetToken() {
  //       return new Promise((resolve, reject) => {
  //         //发送请求获取鉴权信息
  //         $.ajax({
  //           url: "https://iov.anchezhixing.com/api/v2/callRecord/token", //客户提供相应后端接口;负责生成token给前端
  //           type:"GET",
  //           headers:{
  //               'access_token':localStorageUtil.getItem('access_token')
  //           }
  //         }).then((response:any) => {
  //           resolve(response.data);
  //         });
  //       });
  //     }
  //   }
  //   // s4环境示例
  //   //@ts-ignore
  //   let UdeskCCPaasApiClassInstance = new UdeskCCPaasApiClass({
  //       AgentId: localStorage?.getItem("code"),
  //       AppId: "fc0e16c8-f7ac-4f29-7315-40fa6e1cf116",
  //       AppDataProvider: new AppDataProvider(),
  //       Domain: "wss://tower-xcc1.s4.udesk.cn:443/ws",
  //       HttpDomain: "https://apigw-xcc1.s4.udesk.cn:443/backend",
  //       Log: function (message:any, type:any) {
  //       }
  //   });
  //   UdeskCCPaasApiClassInstance.Init();
  //   UdeskCCPaasApiClassInstance.on("Delivered",function(resp:any){
  //     if (plateNumberModal) {
  //       setPlateNumberModal(false)
  //       plateNumberPhone(resp.Data.CallerInfo.TelNumber)
  //     }
  //   })
  // }

  // // 弹框提示
  // const plateNumberPhone = async (value:any) => {
  //   const searchParams = {
  //     page:1,
  //     limit:999,
  //     phone: value,
  //   };
  //   const res = await carListRequest(searchParams);
  //   Modal.info({
  //     title: `${value} 电话下的车辆`,
  //     content: (
  //       <div>
  //         {res?.data?.data.map((item:any) => (
  //           <div key={item.id}>{item.plate_number}</div>
  //         ))}
  //       </div>
  //     ),
  //     onOk() {
  //       setPlateNumberModal(true)
  //     },
  //   });
  // }

  // WebSocket 推送
  const openWs = async () => {
    // setInterval(() => {
    //   console.log('datadatadata')
    //   dealMessage({data:'{"type":"ORDER"}'});
    // }, 1000)
    try {
      // console.log("触发连接 ", new Date());
      if (lockReconnect) return;
      // console.log("触发开启连接 ", new Date());
      const res = await getInformationListRequest();
      setInformationList(res.data?.data)
      const ws = new WebSocket(getWebSocketPath('/ws/customerService', true)); //获取WebSocket路径
      ws.onopen = () => {
        // console.log("message is build ");
      }
      ws.onmessage = (event) => {
        dealMessage(event);
      }
      ws.onerror = () => {
        // console.log("message  has error");
      }
      ws.onclose = () => {
        // console.log('message close ');
        // openWs();
        reconnect();

      }
    } catch (error) {
    }
  }

  const reconnect = () => {
    setLockReconnect(true)
    setTimeout(function () {
      if (localStorage.getItem("userDetail-websoket")) {
        openWs();
        setLockReconnect(false)
      }     //没连接上会一直重连，设置延迟避免请求过多
    }, 10000);
  }

  // WebSocket Alarm808 推送
  const openWsAlarm808 = async () => {
    try {
      if (lockReconnectAlarm808) return;
      const wsAlarm808 = new WebSocket(getWebSocketPath('/ws/alarm808', true)); //获取WebSocket路径
      wsAlarm808.onopen = () => {
        // console.log("alarm808 connection is build");
      }
      wsAlarm808.onmessage = (event) => {
        dealAlarm808Message(event);
      }
      wsAlarm808.onerror = () => {
        // console.log("alarm808 connection has error");
      }
      wsAlarm808.onclose = () => {
        // console.log('alarm808 connection close');
        reconnectAlarm808();
      }
    } catch (error) {
      console.log("alarm808 connection error:", error);
    }
  }

  const reconnectAlarm808 = () => {
    setLockReconnectAlarm808(true)
    setTimeout(function () {
      // if (localStorage.getItem("userDetail-websoket")) {
        openWsAlarm808();
        setLockReconnectAlarm808(false)
      // }     //没连接上会一直重连，设置延迟避免请求过多
    }, 10000);
  }

  // 处理alarm808消息
  const dealAlarm808Message = (event: any) => {
    // console.log("接收到alarm808消息：", event)
    try {
      const alarmData = JSON.parse(event.data);
      // 格式化报警类型
      const alarmTypeLabel = displayJtDeviceAlarmV2({
        alarmType: alarmData.alarmType,
        warningType: alarmData.warningType
      });
      
      // 格式化时间
      const formattedTime = dayjs(alarmData.reportTime).format('YYYY-MM-DD HH:mm:ss');

      // 防抖处理：2000毫秒内只显示第一个消息提示
      if (alarm808MessageTimerRef.current) {
        // 如果timer已存在，说明在2000ms内，忽略后续消息
        return;
      }
      // 播放报警音
      // playInformationAlarm(true);
      const music = (document.getElementById('alarm') as HTMLElement as any)
      music?.play();
      // 立即显示消息提示，点击可跳转到推送记录页面
      message.warning({
        content: `【${alarmData.plateNumber}】：${alarmTypeLabel}，时间：${formattedTime} 点击此消息跳转到推送记录页面进行查看`,
        duration: 2,
        onClick: () => {
          dispatch({
            type: 'addTab',
            payload: {
              tab: '推送记录',
              key: '/car-admin/jt-alarm-record',
            }
          });
        },
        style: { cursor: 'pointer' }
      });

      

      // 设置timer，500ms后清除，允许下一个消息显示
      alarm808MessageTimerRef.current = setTimeout(() => {
        alarm808MessageTimerRef.current = null;
      }, 2000);
    } catch (error) {
      console.error('alarm808 message parse error:', error);
    }
  }


  const dealMessage = (event: any) => {
    // console.log("接收到消息：", event)
    // 如果消息中的 code 不为 0，则处理消息内容
    if (JSON.parse(event.data).code !== 0) {
      // 解析消息数据，并添加发送时间、将已读时间设置为 null
      const aaa = JSON.parse(event.data)
      aaa.sendTime = dayjs(aaa.sendTime).format('YYYY-MM-DD HH:mm:ss')
      aaa.readTime = null
      // 更新信息列表，将新的消息添加到列表中
      setInformationList((OldAlarmData: any) => {
        const newAlarmData = [aaa, ...OldAlarmData];
        return newAlarmData;
      })
      // 根据消息类型播放相应的提示音，并打开消息弹窗
      if (JSON.parse(event.data).type == "ORDER") {
        playInformationOrder(true)
        messageApi.open({
          content: <div style={{ display: 'flex' }}><OrderIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      } else if (JSON.parse(event.data).type == "CUSTOMERTASK") {
        playInformationCustomertask(true)
        messageApi.open({
          content: <div style={{ display: 'flex' }}><CustomertaskIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      } else if (JSON.parse(event.data).type == "ALARM") {
        playInformationAlarm(true)
        messageApi.open({
          content: <div style={{ display: 'flex' }}><AlarmIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      } else if (JSON.parse(event.data).type == "CUSTOMECOMMENT") {
        messageApi.open({
          content: <div style={{ display: 'flex' }}><CustomecommentIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      } else if (JSON.parse(event.data).type == "UNDERWRITING") {
        messageApi.open({
          content: <div style={{ display: 'flex' }}><UnderwritingIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      } else if (JSON.parse(event.data).type == "VIDEO_NOTICE") {
        messageApi.open({
          content: (
            <div style={{ display: 'flex' }}>
              <div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div>
            </div>
          ),
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      }
      else {
        playInformationAlarm(true)
        messageApi.open({
          content: <div style={{ display: 'flex' }}><AlarmIcon /><div style={{ lineHeight: '37px' }}>{JSON.parse(event.data).content}</div></div>,
          style: { verticalAlign: 'baseline' },
          duration: 3,
        });
      }
    }
  }


  // 已读消息
  const informationRead = async (value: any) => {
    const res = await upsertInformationListRequest(value);
    // console.log('value已读', value)
    // console.log('已读成功res', res)
    const abc: any[] = []
    informationList.map((item: any) => {
      if (item.id !== value.id) {
        abc.push(item)
      }
      if (abc.length == informationList.length - 1) {
        setInformationList(abc)
      }
    })
  }

  // 已读带处理消息
  const informationDispose = async (value: any) => {
    const res = await upsertInformationListRequest(value);
    // console.log('已读带处理成功res', res)
    // console.log('value处理', value)
    const abc: any[] = []
    informationList.map((item: any) => {
      if (item.id !== value.id) {
        abc.push(item)
      }
      if (abc.length == informationList.length - 1) {
        setInformationList(abc)
      }
    })
    if (value.type == "CUSTOMERTASK") {
      dispatch({
        type: 'addTab',
        payload: {
          tab: '客服任务',
          key: '/car-admin/service-task',
        }
      })
    } else if (value.type == "ORDER") {
      dispatch({
        type: 'addTab',
        payload: {
          tab: '运维工单',
          key: '/car-admin/work-order',
        }
      })
    } else if (value.type == "ALARM") {
      dispatch({
        type: 'addTab',
        payload: {
          tab: 'adas报警查询',
          key: '/car-admin/adas-alarm-search',
        }
      })
    } else if (value.type == "UNDERWRITING") {
      dispatch({
        type: 'addTab',
        payload: {
          tab: '承保记录',
          key: '/car-admin/ceshi',
        }
      })
    } else if (value.type == "INTERCOM") {
      dispatch({
        type: 'addTab',
        payload: {
          tab: '实时监控',
          key: '/car-admin/real-monitoring',
          params: { plateNumber: value.obj }
        }
      })
    }
  }

  // 已读全部消息
  const informationReadAll = async () => {
    const res = await getInformationListRequest();
    res?.data?.data.map(async (item: any) => {
      const res = await upsertInformationListRequest(item);
      setInformationList([])
    })
  }

  //查看并跳转评论界面
  const viewServiceDetails = async (value: any) => {
    // console.log('obj', value.obj);
    dispatch({
      type: 'addTab',
      payload: {
        tab: '客服任务处理',
        key: '/car-admin/service-task-dispose',
        params: { plateNumber: value.obj }
      }
    })
  }

  // 退出登录
  const logout = async () => {
    // 清除登录的用户信息
    dispatch({ type: 'logout' });
    dispatch({ type: 'resetTab' });
    localStorage.removeItem("userDetail-websoket")
    message.success('退出成功');
  }

  // 修改密码
  const modifyPassword = () => {
    setModifyVisible(true);
  }

  // 控制声音
  const controlSound = () => {
    setSoundSwitch(!soundSwitch)
  }

  // 播放工单铃声
  const playInformationOrder = (value: any) => {
    if (soundSwitch == true || value == true) {
      const music = (document.getElementById('order') as HTMLElement as any)
      music?.play();
    }
  }
  // 播放客服铃声
  const playInformationCustomertask = (value: any) => {
    if (soundSwitch == true || value == true) {
      const music = (document.getElementById('customertask') as HTMLElement as any)
      music?.play();
    }
  }
  // 播放报警铃声
  const playInformationAlarm = (value: any) => {
    if (soundSwitch == true || value == true) {
      const music = (document.getElementById('alarm') as HTMLElement as any)
      music?.play();
    }
  }

  const onChange = async (value: any) => {
    setOnLineSwitch(!onLineSwitch)
    const res = await getCustomer();
    const params = { ...res.data.data }
    if (value == true) {
      params.state = 1
      const ress = await upsertserviceOnLineRequest(params);
      if (ress.data?.code === 0) {
        message.success('开启成功');
      }
    } else {
      params.state = 0
      const ress = await upsertserviceOnLineRequest(params);
      if (ress.data?.code === 0) {
        message.success('关闭成功');
      }
    }
  }

  // 渲染快捷菜单
  const renderMenu = () => {
    return (
      <div className={styles.menuBox}>
        {menuData.map((menuGroup: any) => (
          <div className={styles.menuGroup} key={menuGroup.key}>
            <div className={styles.menuTitle}>{menuGroup.label}</div>
            <div className={styles.menuItemGroup}>
              {menuGroup.children.map((menuItem: any) => (
                <div
                  className={styles.menuItem}
                  key={menuItem.key}
                  title={menuItem.label}
                  onClick={() => {
                    setMenuOpen(false);
                    onMenuSelect(menuItem.key, menuItem.label, toggleCollapse);
                  }}
                >
                  {menuItem.label}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Header className={styles.layoutHeader}>
      <div className={styles.logoTitle} style={collapsed ? { width: '80px' } : {}}>
        <span style={{ display: collapsed ? 'none' : 'inline', marginRight: '4px' }}>
          {getPageTitle(userDetail)}
        </span>
        <img src={userDetail?.iconUrl} alt="logo" style={{ visibility: collapsed ? 'visible' : 'hidden' }} />
      </div>
      <div className={styles.headerContent}>
        <div>
          {/* 展开收起menu的按钮 */}
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: styles.toggleIcon,
            onClick: toggleCollapse,
          })}
          <Dropdown
            dropdownRender={renderMenu}
            placement="bottom"
            onOpenChange={(open: boolean) => setMenuOpen(open)}
            open={menuOpen}
          >
            <span className={styles.quickMenu} style={{ marginLeft: '10px' }}>快捷菜单</span>
          </Dropdown>
        </div>
        <div style={{ display: 'flex' }}>
          <div className={styles.checkBox}>
            {getVideoPermission && <div>是否接收语音提醒<Switch checked={accpetVideo} onChange={videoChange} /></div>}
            {serviceOnLinePermission && <div>
              是否接收客服任务
              <Switch checked={onLineSwitch} onChange={onChange} />
            </div>}
          </div>

          {jtAlarmCntPermission && <JtAlarmCountIcon
            style={{ marginRight: '16px', display: 'flex', alignItems: 'center', marginLeft: '30px' }}
            onClick={() => {
              dispatch({
                type: 'addTab',
                payload: {
                  tab: '推送记录',
                  key: '/car-admin/jt-alarm-record',
                }
              });
            }}
          />}
          <div className={styles.information} >
            <div className={styles.informationText}>
              <div onClick={controlSound}>
                {soundSwitch !== false ? <CloseSoundIcon style={{ verticalAlign: '-4px' }} /> : <OpenSoundIcon style={{ verticalAlign: '-4px' }} />}
              </div>
              <div>&nbsp;消息</div>
              {contextHolder}
              {informationList.length > 0 ? <div className={styles.informationNum}>{informationList.length}</div> : <div></div>}
              {soundSwitch == false ? <div style={{ display: 'none' }}>
                <video src={orderMp} id="order" muted={true} ></video>
                <video src={customertaskMp} id="customertask" muted={true}></video>
                <video src={alarmMp} id="alarm" muted={true}></video>
              </div> : <div></div>}
              <div className={styles.informationBox}>
                {informationList.length > 0 ? <div className={styles.informationBoxReadAll} onClick={informationReadAll}>已读<br />全部</div> : null}
                {informationList.length > 0 ? informationList.map((item: any, index: any) => (
                  <div className={styles.informationBoxItem} key={index}>
                    <div>
                      {item.type == 'ORDER' ? <OrderIcon /> : item.type == 'CUSTOMERTASK' ? <CustomertaskIcon /> : item.type == 'ALARM' ? <AlarmIcon /> : item.type == 'CUSTOMECOMMENT' ? <CustomecommentIcon /> : item.type == 'UNDERWRITING' ? <UnderwritingIcon /> : null}
                    </div>
                    <div className={styles.informationBoxCenter}>
                      <div>{item.sendTime}</div>
                      <div style={{ fontSize: '12px', color: 'rgb(168, 168, 168)' }}>{item.content}</div>
                    </div>
                    <div className={styles.informationBoxButton}>
                      <div className={styles.informationBoxButtonItem} onClick={() => informationRead(item)}>已读</div>
                      <div className={styles.informationBoxButtonItem} onClick={() => informationDispose(item)}>处理</div>
                      {item.type == 'CUSTOMERTASK' && <div className={styles.informationBoxButtonItem} onClick={() => viewServiceDetails(item)}>查看</div>}
                    </div>
                  </div>
                )) : <div><NotInformationIcon style={{ padding: '90px 0 0 125px' }} /><div style={{ color: '#e6e6e6', textAlign: 'center', paddingTop: '10px' }}>暂无消息</div></div>}
              </div>
            </div>
          </div>
          <Dropdown
            trigger={['hover']}
            overlay={
              <Menu
                items={[
                  {
                    key: 'videoDuration',
                    label: (<div onMouseEnter={getVideoDuration}>剩余时长:{videoDuration == undefined ? '查询' : videoDuration + `min`}</div>),
                  },
                  {
                    key: 'modifyPassword',
                    label: (<div onClick={modifyPassword}>修改密码</div>),
                  },
                  {
                    key: 'signout',
                    label: (<div onClick={logout}>退出</div>),
                  },
                ]}
              />
            }
          >
            <span className={styles.userName}>
              <UserOutlined />
              {userDetail?.nickname}
            </span>
          </Dropdown>


        </div>
      </div>
      <div>
      </div>
      {modifyVisible && <ModifyPasswordModal closeModal={() => setModifyVisible(false)} />}
    </Header>
  )
}

export default MainHeader;
